/* import __COLOCATED_TEMPLATE__ from './disintermediation-thread-warning.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { showModal } from 'sh-www/utils/modal-controls';
import clsx from 'clsx';
import ENV from 'sh-www/config/environment';

const CLASS_NAME = 'disintermediation-thread-warning';
const DEFAULT_VARIANT = 'project-details';
const LEARN_MORE_LINKS = {
  BUYER: `https://${ENV.supportDomain}/en/articles/8392523-learn-about-the-dos-and-don-ts-when-posting-projects-on-glimmer`,
  SELLER: `https://${ENV.supportDomain}/en/articles/8392437-learn-about-the-dos-and-don-ts-when-applying-to-postings-on-glimmer`,
};

class DisintermediationThreadWarning extends Component {
  get classNames() {
    return clsx(
      CLASS_NAME,
      this.args.variant && `${CLASS_NAME}--${this.args.variant}`,
      !this.args.variant && `${CLASS_NAME}--${DEFAULT_VARIANT}`,
    );
  }

  get learnMoreLink() {
    return this.args.currentUser.isSeller ? LEARN_MORE_LINKS.SELLER : LEARN_MORE_LINKS.BUYER;
  }

  get showReportLink() {
    return this.args.message.userId !== this.args.currentUser.id;
  }

  @action
  onReportClicked() {
    const modalModel = {
      threadId: this.args.message.thread.id,
    };

    showModal(this, 'flag-user-modal', modalModel);
  }
}

export default DisintermediationThreadWarning;
